import React from 'react';
import Modal from 'react-modal';

export const FModal = ({
  isOpen,
  close,
  children,
  onClose,
  widthAuto,
  marginRight = '-50px',
}) => {
  const customStyles = {
    content: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight,
      transform: 'translate(-50%, -50%)',
      backgroundColor: '#fff',
      padding: '1.8rem 2rem',
      width: widthAuto ? 'auto' : '332px',
      maxHeight: '95vh',
    },
    overlay: {
      position: 'fixed',
      display: 'flex',
      justifyContent: 'center',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      zIndex: '1000',
      overflowY: 'auto',
      backgroundColor: 'rgba(0,0,0,0.85)',
    },
  };
  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      shouldCloseOnOverlayClick
      onRequestClose={onClose}
      contentLabel="Forluz Modal"
    >
      {close ? (
        <i
          className="close-icon icon-clear"
          onClick={() => {
            onClose();
          }}
          aria-hidden
        />
      ) : (
        ''
      )}
      {children}
    </Modal>
  );
};
